import { LISTING_INDEXES } from '@helpers/algolia/constants';
import productHitAdapter from '@helpers/algolia/product-hit-adapter';
import getAlgoliaClientLite from '@services/algolia/getAlgoliaClientLite';
import { TProduct } from 'types/product';

type TGetProductsFromAlgoliaByFilter = {
  facetFilters: string[];
  searchOptions?: Record<string, any>;
  index?: string;
  sellerId?: string;
  filters?: string;
};

export default async function getProductsFromAlgoliaByFilter({
  filters,
  facetFilters,
  searchOptions = null,
  index = LISTING_INDEXES[0].value,
  sellerId,
}: TGetProductsFromAlgoliaByFilter): Promise<TProduct[]> {
  const algoliaClient = getAlgoliaClientLite();
  const listingIndex = algoliaClient.initIndex(index);
  const response = await listingIndex.search('', {
    facets: ['*'],
    filters,
    facetFilters,
    ...searchOptions,
  });
  return response.hits.map(product => productHitAdapter(product, sellerId));
}
